import { ref, onMounted, onUnmounted } from 'vue';

/**
 * Keep track of component mounted state
 */
function useMounted() {
  const isMounted = ref(false);
  onMounted(() => isMounted.value = true);
  onUnmounted(() => isMounted.value = false);
  return isMounted;
}
export { useMounted };